module.exports = __webpack_public_path__ + "img/bigScreen.c8dd99c8.jpg";